import styles from './AssetTone.module.css';

/** The lattice theme colors an asset's header tile can take. */
export const ASSET_TONES = [
  'primary',
  'brand',
  'success',
  'warning',
  'destructive',
  'informative',
  'chart-1',
  'chart-2',
  'chart-3',
  'chart-4',
  'chart-5',
  'chart-6',
  'chart-7',
  'chart-8',
  'chart-9',
  'chart-10',
  'alternate-1',
  'alternate-2',
  'alternate-3',
  'alternate-4',
  'alternate-5',
  'alternate-6',
  'alternate-7',
  'alternate-8',
  'alternate-9',
] as const;

/** One of {@link ASSET_TONES}. */
export type TAssetTone = (typeof ASSET_TONES)[number];

/**
 * The class that sets `--asset-tone` to a lattice theme colour.
 *
 * @param tone - The tone
 * @returns Its class name
 */
export function getAssetToneClass(tone: TAssetTone): string | undefined {
  return styles[tone];
}
